import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top on every route change.
 * Also fires Meta Pixel PageView on every SPA route change so ad reporting
 * reflects real navigation, not just the initial document load.
 * Preserves scroll on back/forward navigation (browser handles that natively).
 * Also respects hash links (e.g. /page#section) — those keep browser default behavior.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // Let the browser scroll to the #anchor
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });

    // Meta Pixel: track PageView on every SPA route change (base pixel already fires on first load)
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [pathname, hash]);

  return null;
}
